(() => {
  if (customElements.get('truevue-product-information')) return;
  customElements.define('truevue-product-information', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.splitSpecifications());
    }

    splitSpecifications() {
      if (this.dataset.splitComplete) return;
      const source = this.querySelector('[data-description-source]');
      const target = this.querySelector('[data-specifications-content]');
      if (!source || !target) return;
      const walker = document.createTreeWalker(source, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
        acceptNode: node => {
          if (node.nodeType === Node.ELEMENT_NODE) return node.tagName === 'BR' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
          return node.parentElement.closest('script, style, template') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
        }
      });
      const entries = [];
      let text = '';
      let previousBlock;
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          text += '\n';
          continue;
        }
        const block = node.parentElement.closest('p, h1, h2, h3, h4, h5, h6, div, li, td, th');
        if (entries.length && block !== previousBlock) text += '\n';
        entries.push({ node, start: text.length });
        text += node.textContent;
        previousBlock = block;
      }
      const match = /(^|[^\p{L}\p{N}_])specificaties(?=$|[^\p{L}\p{N}_])/iu.exec(text);
      if (!match) {
        this.dataset.splitComplete = 'true';
        return;
      }
      const index = match.index + match[1].length;
      const entry = entries.find(item => index >= item.start && index < item.start + item.node.length);
      if (!entry) return;
      const range = document.createRange();
      range.setStart(entry.node, index - entry.start);
      let ancestor = entry.node.parentElement;
      while (ancestor && ancestor !== source) {
        const prefix = document.createRange();
        prefix.selectNodeContents(ancestor);
        prefix.setEnd(entry.node, index - entry.start);
        const content = prefix.cloneContents();
        if (content.textContent.trim() || content.querySelector('img, video, iframe, svg, audio, hr, input')) break;
        range.setStartBefore(ancestor);
        ancestor = ancestor.parentElement;
      }
      range.setEnd(source, source.childNodes.length);
      target.prepend(range.extractContents());
      this.dataset.splitComplete = 'true';
    }
  });
})();
